import React from 'react';
import Button from './Button';
import Terminal from './Terminal';
import '../styles/Home.css';

const Home: React.FC = () => {
  return (
    <main className="home-section" id="home">
      <div className="home-content">
        <h1 className="title">
          <span className="title-main">Developer &</span>
          <span className="title-sub">
            <span className="security">Security</span>
            <span className="engineer">Engineer</span>
          </span>
        </h1>
        <p className="tagline">Crafting secure code and innovative solutions at the intersection of development and cybersecurity.</p>

        <div className="cta-buttons">
          <Button href="/experience" text="Job Experience" isPrimary={true} isRouterLink={true} />
          <Button href="/blog" text="Blog" isRouterLink={true} />
        </div>
      </div>

      <Terminal />
    </main>
  );
};

export default Home; 